import React from 'react'
import style from "./changelLoader.module.css"
const ChangelLoader=()=>{
    return(
        <div className={style.custom_loader_change}></div>
    )
}
export default ChangelLoader;